import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=78232930&scoped=true&"
import script from "./CreateEmail.vue?vue&type=script&lang=js&"
export * from "./CreateEmail.vue?vue&type=script&lang=js&"
import style0 from "./CreateEmail.vue?vue&type=style&index=0&id=78232930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78232930",
  null
  
)

export default component.exports